<template>
	<div class="full page_container">
		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="关键词推广" name="keyword" style="height: 100%;">
				<keyword-list />
			</el-tab-pane>
			<el-tab-pane label="全站推广" name="allarea" style="height: 100%;">
				<allarea-list />
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<style scoped>
	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import keywordList from './list/keyword'
	import allareaList from './list/allarea'
	export default {
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				activeName:'keyword'
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {

		},
		components: {
			keywordList,
			allareaList
		}
	}
</script>